import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import styled from "styled-components";
import { size, colors } from "../../../../shared/constants";
import { Text as RadioButtonText, Label as RadioButtonLabel } from "../../../RadioButton/styles";
var RadioGroup = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  padding: ", "px 0 ", "px;\n  gap: ", "px ", "px;\n"])), size.md, size.lg, size.md, size.lg),
    RadioButtonWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 50%;\n  padding: ", "px ", "px;\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n  box-shadow: 4px 4px 15px -5px rgba(0 0 0 / 10%);\n  border-radius: 1px;\n\n  ", " {\n    line-height: 2;\n  }\n\n  ", " {\n    width: 100%;\n  }\n"])), size.xs1, size.md, function (o) {
  return o.checked ? colors.green4 : colors.green2;
}, function (o) {
  return o.checked ? colors.green1 : "transparent";
}, RadioButtonText, RadioButtonLabel);
export { RadioGroup, RadioButtonWrapper };